<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TrainingMain',
  beforeRouteUpdate(to, from, next) {
    if (!this.trainingContent) {
      this.fetchTrainingContent({ id: to.params.trainingId })
    }
    next()
  },
  beforeDestroy() {
    this.setPanels([])
    this.setTrainingContent(null)
  },
  mounted() {
    if (!this.trainingContent) {
      this.fetchTrainingContent(this.$route.params.trainingId)
    }
  },
  computed: {
    ...mapGetters({
      trainingContent: 'training/getTrainingContent'
    })
  },
  methods: {
    ...mapActions({
      fetchTrainingContent: 'training/fetchTrainingContent'
    }),
    ...mapMutations({
      setTrainingContent: 'training/setTrainingContent',
      setPanels: 'training/setPanels'
    })
  }
}
</script>

<style scoped>

</style>
